"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _index = _interopRequireDefault(require("@/layout/index.vue"));
var _categorySubMenu = require("./subMenus/category-sub-menu");
var _brandsSubMenu = require("./subMenus/brands-sub-menu");
const productRouter = {
  path: '/product',
  component: _index.default,
  redirect: 'noredirect',
  name: 'productManagement.title',
  meta: {
    roles: ['Super Admin', 'System Admin', 'Admin', 'Sales Coordinator', 'Sales Manager'],
    title: 'productManagement.title',
    icon: 'shopping'
  },
  children: [{
    path: '/attribute/list',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/attribute/list.vue'))),
    name: 'productManagement.attribute.title',
    meta: {
      title: 'productManagement.attribute.title',
      roles: ['Super Admin', 'Admin', 'System Admin'],
      noCache: true,
      icon: 'sack',
      hidden: true
    }
  }, {
    path: '/attribute/add',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/attribute/manage.vue'))),
    name: 'productManagement.attribute.add',
    props: {
      isEdit: false
    },
    meta: {
      title: 'productManagement.attribute.add',
      noCache: true,
      hidden: true
    }
  }, {
    path: '/attribute/edit/:id(\\d+)',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/attribute/manage.vue'))),
    name: 'productManagement.attribute.edit',
    props: {
      isEdit: true
    },
    meta: {
      title: 'productManagement.attribute.edit',
      noCache: true,
      hidden: true
    }
  }, {
    path: '/products-fields-value/list/:id',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/products-fields-value/list.vue'))),
    name: 'productManagement.productsFieldsValue.title',
    meta: {
      title: 'productManagement.productsFieldsValue.title',
      roles: ['Super Admin', 'Admin', 'System Admin'],
      noCache: true,
      icon: 'sack',
      hidden: true
    }
  }, {
    path: '/products-fields-value/add/:id(\\d+)',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/products-fields-value/manage.vue'))),
    name: 'productManagement.productsFieldsValue.add',
    props: {
      isEdit: false
    },
    meta: {
      title: 'productManagement.productsFieldsValue.add',
      noCache: true,
      hidden: true
    }
  }, {
    path: '/products-fields-value/edit/:id(\\d+)',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/products-fields-value/manage.vue'))),
    name: 'productManagement.productsFieldsValue.edit',
    props: {
      isEdit: true
    },
    meta: {
      title: 'productManagement.productsFieldsValue.edit',
      noCache: true,
      hidden: true
    }
  }, {
    path: '/attribute-value/list/:id',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/attribute-value/list.vue'))),
    name: 'Attribute Value',
    meta: {
      title: 'productManagement.attributevalue.title',
      roles: ['Super Admin', 'Admin', 'System Admin'],
      noCache: true,
      activeMenu: '/attribute/list',
      hidden: true
    }
  }, {
    path: '/attribute-value/add/:id(\\d+)',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/attribute-value/manage.vue'))),
    name: 'Manage Attribute Value',
    props: {
      isEdit: false
    },
    meta: {
      title: 'productManagement.attributevalue.manage',
      noCache: true,
      hidden: true
    }
  }, {
    path: '/attribute-value/edit/:id(\\d+)',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/attribute-value/manage.vue'))),
    name: 'productManagement.attributevalue.manage',
    props: {
      isEdit: true
    },
    meta: {
      title: 'productManagement.attributevalue.manage',
      noCache: true,
      hidden: true
    }
  }, {
    path: '/product/list',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/products/list.vue'))),
    name: 'productManagement.product.title',
    meta: {
      title: 'productManagement.product.title',
      icon: 'example',
      noCache: true
    }
  }, {
    path: '/product/add',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/products/manage.vue'))),
    name: 'productManagement.product.manage',
    props: {
      isEdit: false
    },
    meta: {
      title: 'productManagement.product.manage',
      roles: ['Super Admin', 'Admin', 'System Admin', 'Sales Coordinator', 'Sales Manager'],
      noCache: true,
      hidden: true
    }
  }, {
    path: '/product/edit/:id(\\d+)',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/products/manage.vue'))),
    name: 'productManagement.product.manage',
    props: {
      isEdit: true
    },
    meta: {
      title: 'productManagement.product.manage',
      roles: ['Super Admin', 'Admin', 'Sales Coordinator', 'Sales Manager', 'System Admin'],
      noCache: true,
      hidden: true
    }
  }, {
    path: '/product/import',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/products/import.vue'))),
    name: 'productManagement.product.import',
    props: {
      isEdit: false
    },
    meta: {
      title: 'productManagement.product.import',
      noCache: true,
      hidden: true
    }
  }, ..._categorySubMenu.categoriesSubMenu, ..._brandsSubMenu.brandsSubMenu
  //     {
  //       path: '/products-field/list',
  //       component: () => import('@/views/products-field/list.vue'),
  //       name: 'productManagement.productsField.title',
  //       meta: {
  //         title: 'productManagement.productsField.title',
  //         noCache: true,
  //         icon: 'sack',
  //         hidden: false
  //       }
  //     },
  //     {
  //       path: '/products-field/add',
  //       component: () => import('@/views/products-field/manage.vue'),
  //       name: 'productManagement.productsField.add',
  //       props: {
  //         isEdit: false
  //       },
  //       meta: {
  //         title: 'productManagement.productsField.add',
  //         noCache: true,
  //         hidden: true
  //       }
  //     },
  //     {
  //       path: '/products-field/edit/:id(\\d+)',
  //       component: () => import('@/views/products-field/manage.vue'),
  //       name: 'productManagement.productsField.edit',
  //       props: {
  //         isEdit: true
  //       },
  //       meta: {
  //         title: 'productManagement.productsField.edit',
  //         noCache: true,
  //         hidden: true
  //       }
  //     }
  ]
};
var _default = exports.default = productRouter;